import { styled, Button, SvgIcon as MuiSvgIcon } from '@material-ui/core';
import MuiClearIcon from '@material-ui/icons/Clear';
import MuiCheckIcon from '@material-ui/icons/Check';
import MuiBox from 'components/vendor/Box';

export const SvgIcon = styled(MuiSvgIcon)({
  fontSize: 'unset',
});

export const WidgetBox = styled(MuiBox)(({ theme }) => ({
  display: 'inline-flex',
  maxWidth: theme.size.widgetWidth,
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    flexBasis: '100%',
  },
}));

export const TopBar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: theme.size.topBarHeight,
  paddingLeft: 40,
  paddingRight: 23,
  paddingTop: 0,
  paddingBottom: 0,
  background: theme.custom.darkBlue,
  [theme.breakpoints.down('md')]: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  [theme.breakpoints.down('xs')]: {
    paddingLeft: 5,
    paddingRight: 5,
  },
}));

export const Logo = styled('img')(({ theme }) => ({
  display: 'block',
  maxWidth: '100%',
  height: 'auto',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '80%',
    margin: '0 auto',
  },
}));

export const Box = styled('div')({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const PageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  flex: 1,
  padding: '20px 30px',
  overflowX: 'hidden',
  [theme.breakpoints.down('md')]: {
    padding: '15px 10px',
  },
}));

export const CustomPageWrapper = styled('div')({
  flex: 1,
  padding: 0,
});

export const BorderedBox = styled('div')(({ theme }) => ({
  padding: '15px 25px',
  background: '#fff',
  borderLeft: `5px solid ${theme.custom.darkBlue}`,
  borderRadius: 2,
  [theme.breakpoints.down('md')]: {
    padding: '15px 10px',
  },
}));

export const Title = styled('h1')(({ theme }) => ({
  margin: 0,
  marginBottom: 17,
  padding: 0,
  fontSize: 28,
  fontWeight: 600,
  color: theme.custom.darkBlue,
  [theme.breakpoints.down('md')]: {
    fontSize: 21,
  },
  [theme.breakpoints.down('xs')]: {
    flex: 1,
  },
}));

export const Flex = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  [theme.breakpoints.down(theme.size.sm)]: {
    flexDirection: 'column',
  },
}));

export const FlexBlock = styled('div')(({ theme }) => ({
  flex: 1,
  marginRight: 30,
  '&:last-child': {
    marginRight: 0,
  },
}));

export const LoaderWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  color: theme.custom.darkBlue,
}));

export const FiltersBar = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: '20px 25px',
  background: theme.palette.primary.main,
}));

export const IconButton = styled(Button)(({ theme }) => ({
  minWidth: 'auto',
  padding: 2,
  borderRadius: '50%',
}));

export const Centered = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  flex: 1,
});

export const FixCentered = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const BorderedBoxTitle = styled('h2')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontSize: 16,
  fontWeight: 600,
  color: theme.custom.darkBlue,
}));

export const ClearIcon = styled(MuiClearIcon)(({ theme }) => ({
  fontSize: '1.3rem',
  color: theme.custom.warning,
}));

export const CheckIcon = styled(MuiCheckIcon)(({ theme }) => ({
  fontSize: '1.3rem',
  color: theme.custom.accept,
}));

export const FormButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 'auto',
  padding: '5px 15px',
  fontSize: 14,
  fontFamily: 'NeoSansStd',
  borderRadius: 29,
  color: '#fff',
  textTransform: 'uppercase',
}));

export const ApplyButton = styled(FormButton)(({ theme }) => ({
  background: theme.custom.accept,
}));

export const RejectButton = styled(FormButton)(({ theme }) => ({
  background: '#7E8483',
}));

export const DownloadButton = styled(Button)(({ theme }) => ({
  minWidth: 'auto',
  padding: 12,
  fontSize: 14,
  fontFamily: 'NeoSansStd',
  lineHeight: 1,
  background: '#347AC4',
  borderRadius: 29,
  color: '#fff',
  textTransform: 'uppercase',

  '&.Mui-disabled': {
    opacity: 0.3,
  },
}));

export const Aside = styled('div')(({ theme }) => ({
  maxWidth: 404,
  background: '#fff',
  boxShadow: '1px 1px 9px rgba(0, 0, 0, .29)',
}));

export const PurchaseInvoiceText = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  color: theme.custom.darkBlue,
}));

export const PurchaseInvoiceTextGreen = styled(PurchaseInvoiceText)(
  ({ theme }) => ({
    color: theme.custom.accept,
  })
);

export const PurchaseInvoiceTextOrange = styled(PurchaseInvoiceText)(
  ({ theme }) => ({
    color: '#FF7600',
  })
);

export const InvoiceLink = styled('a')(({ theme }) => ({
  display: 'block',
  color: '#555',
  textDecoration: 'none',
  '&:hover': {
    color: theme.custom.lightBlue,
  },
}));

export const ButtonShape = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 'auto',
  padding: '6px 12px',
  fontSize: 14,
  fontFamily: 'NeoSansStd',
  color: '#fff',
  borderRadius: 29,
  textTransform: 'uppercase',
  '&.Mui-disabled': {
    color: '#fff',
  },
}));

export const ControlWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: 10,
});

export const AddonWrapper = styled('div')(({ theme }) => ({
  padding: '15px 25px',
  background: '#fff',
  borderLeft: `5px solid ${theme.custom.darkBlue}`,
}));

export const AddonTitleWrapper = styled('div')(({ theme }) => ({
  padding: '10px 20px',
  background: theme.custom.darkBlue,
}));

export const AddonTitle = styled('p')(({ theme }) => ({
  fontSize: 16,
  fontWeight: 600,
  color: '#fff',
  textTransform: 'capitalize',
}));

export const PropertyLi = styled('li')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  '&:last-child div': {
    marginBottom: 0,
  },
}));

export const PropertyItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: 10,
}));

export const PropertyTitle = styled('span')(({ theme }) => ({
  display: 'flex',
  width: '50%',
  marginRight: 30,
  fontSize: 14,
  color: '#646464',
  [theme.breakpoints.down('sm')]: {
    marginRight: 20,
  },
}));

export const PropertyValue = styled('span')(({ theme }) => ({
  display: 'flex',
  width: '50%',
  fontSize: 14,
  justifyContent: 'flex-end',
  color: theme.custom.darkBlue,
  textAlign: 'right',
  wordBreak: 'break-word',
}));

export const Truncate = styled('span')(() => ({
  display: 'inline-block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'pre-wrap',
}));

export const InfoList = styled('ul')(() => ({
  margin: 0,
  padding: 0,
  listStyle: 'none',
}));

export const InfoRow = styled('li')(() => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 10,
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const InfoColumn = styled(InfoRow)(() => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export const InfoLabel = styled('span')(() => ({
  display: 'block',
  width: '50%',
  marginRight: '30px',
  fontSize: 14,
  color: '#646464',
}));

export const InfoValue = styled('span')(({ theme }) => ({
  display: 'block',
  width: '50%',
  fontSize: 14,
  color: theme.custom.darkBlue,
  textAlign: 'right',
  wordBreak: 'break-word',
  justifyContent: 'flex-end',
}));
